import ShowToast from "@/app/core/components/ToastProvider/ShowToast";
import axios from "axios";  
import Error from "next/error";

const request = async ({ url, method, data = {}, token = null, noAlerts = false }) => {
  const axiosInstance = axios.create({
    headers: { 'Authorization': token }
  });

  try {

    let response = await axiosInstance.request({
      url: url,
      method,
      data
    });

    if (!(response.status >= 200 && response.status <= 299)) {
      throw new Error("Server Error");
    }
    if (response && response.data) {
        return response.data;
    }

  } catch(e) {
    if (!noAlerts) {
      if (e && e.response && e.response.data && e.response.data.statusCode == "403") {
        ShowToast("error", "You are not authorized to access this screen.");
      } else if (e && e.response && e.response.data && e.response.data.statusCode == "400" && e.response.data.message) {
        ShowToast("warning", e.response.data.message);
      } else {
        ShowToast("error", "Sorry, something went wrong. We're fixing it. Please try again later.");
      }
    }
  }
  return null
}

export default request;